import enrollMixin from '@/components/enroll/enrollMixin.js'
export default {
  mixins: [enrollMixin],
  data() {
    return {
      // 学段动态class
      isPeriodActive: false,
      // 学段的值
      periodValue: '',
      // 学科的值
      subjectValue: '',
      // 学段可选数据
      period: [
        {
          name: '小学',
          level: 1
        },
        {
          name: '初中',
          level: 2
        },
        {
          name: '高中',
          level: 4
        }
      ],
      // 学科可选数据
      subject: [
        {
          name: '语文',
          value: 'CHINESE'
        },
        {
          name: '数学',
          value: 'MATH'
        },
        {
          name: '英语',
          value: 'ENGLISH'
        },
        {
          name: '物理',
          value: 'PHYSICS'
        },
        {
          name: '化学',
          value: 'CHEMISTRY'
        },
        {
          name: '生物',
          value: 'BIOLOGY'
        },
        {
          name: '历史',
          value: 'HISTORY'
        },
        {
          name: '地理',
          value: 'GEOGRAPHY'
        },
        {
          name: '政治',
          value: 'POLITICS'
        }
      ]
    }
  },
  computed: {
    // 下一步按钮禁用
    baseInfoUsable() {
      return this.name && this.periodValue && this.subjectValue
    }
  },
  mounted() {
    // 所有学科添加不可点击事件
    $('.subject').addClass('disabled')
  },
  methods: {
    // 选择学段
    choosePeriod(item, index) {
      this.isPeriodActive = index
      $('.subject').removeClass('subject-active')
      this.periodValue = item.level
      // 选择小学
      if (item.level === 1) {
        $('.subject').addClass('disabled')
        // 语文、数学、英语可点击
        $('.subject')
          .filter((item) => item <= 2)
          .removeClass('disabled')
      } else {
        $('.subject').removeClass('disabled')
      }
      window['sensors'].track('RegisterBasicInformationPage_buttonClick', {
        buttonName: '学段'
      })
    },
    // 选择学科
    chooseSubject(item, index) {
      $('.subject').removeClass('subject-active')
      $($('.subject')[index]).addClass('subject-active')
      this.subjectValue = item.value
      window['sensors'].track('RegisterBasicInformationPage_buttonClick', {
        buttonName: '学科'
      })
    },
    // 下一步
    async nextStep() {
      // 验证姓名
      if (!/^[\u4e00-\u9fa5]{2,10}$/.test(this.name)) {
        this.nameError = '请输入中文2-10位中文名字'
        return
      }
      // 跳转到选择学校界面并传入参数
      this.$emit('changeCurrnetTab', 3, {
        realname: this.name,
        ktwelve: this.periodValue,
        subject: this.subjectValue
      })
      window['sensors'].track('RegisterBasicInformationPage_buttonClick', {
        buttonName: '下一步'
      })
    }
  }
}
